module.exports = "<div class=\"row mt-3 d-print-none\">\r\n    <div class=\"col-6 text-left \">\r\n        <button class=\"btn btn-link\" (click)=\"location.back()\">\r\n            <i class=\"fas fa-arrow-left fa-lg mr-1\"></i> <span class=\"h3\">Regresar</span> \r\n        </button>\r\n    </div>\r\n</div> "


//////////////////
// WEBPACK FOOTER
// ./src/app/components/partials/back-link/back-link.component.html
// module id = ./src/app/components/partials/back-link/back-link.component.html
// module chunks = main